import { Card } from '@shopify/polaris';
import { MEASURE_BY_KEY } from './constants';
import { INK, INK_SOFT, LINE } from './pivotStyles';

/** Mismo orden que las medidas de la barra. */
const KPI_MEASURES = [
  { key: 'qty', label: 'Unidades' },
  { key: 'families', label: 'Series-color' },
  { key: 'cost', label: 'Valor coste' },
  { key: 'pvf', label: 'Valor PVF' },
  { key: 'pvp', label: 'Valor PVP' },
];

/**
 * Franja de KPIs del total. Depende de fechas y filtros, no del pautado:
 * cambiar filas o columnas no la mueve. Cifras completas, sin escala. Con
 * comparativa, bajo cada cifra va la de la fecha de comparación y la
 * variación.
 */
export const StocksKpis = ({ root, fmt, compareLabel }) => (
  <Card>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))' }}>
      {KPI_MEASURES.map(({ key, label }, i) => {
        const c = root?.cells?.TOTAL?.[key];
        const kind = MEASURE_BY_KEY[key].kind;
        const delta = compareLabel && c ? fmt.deltaPct(c) : '';
        return (
          <div
            key={key}
            style={{ padding: '4px 16px', borderLeft: i === 0 ? 'none' : `1px solid ${LINE}`, minWidth: 0 }}
          >
            <div style={{ fontSize: 13, color: INK_SOFT }}>{label}</div>
            <div
              style={{
                fontSize: 24,
                fontWeight: 600,
                color: INK,
                lineHeight: '32px',
                fontVariantNumeric: 'tabular-nums',
                whiteSpace: 'nowrap',
              }}
            >
              {c ? fmt.kpi(kind, c.value) : ' '}
            </div>
            {compareLabel && c && (
              <div style={{ fontSize: 12, color: INK_SOFT, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
                {`${compareLabel}: ${fmt.kpi(kind, c.compare)}`}
                {delta && delta !== 'nueva' && delta !== 'sin base' ? ` (${delta} %)` : ''}
              </div>
            )}
          </div>
        );
      })}
    </div>
  </Card>
);
